import { useQuery } from '@tanstack/react-query'

import { getShipUserPreference } from './userProfile.service'

export const useShipUserPreference = (enabled: boolean) => {
  return useQuery({
    queryKey: ['shipUserPreference'],
    queryFn: getShipUserPreference,
    enabled: enabled,
    retry: 3,
  })
}
